import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectFontFamilyOption')(function selectFontFamilyOption(fontFamily, state) {
    var optionState = state.optionState;
    optionState.fontFamily = fontFamily;
}));
//# sourceMappingURL=selectFontFamilyOption.js.map